import Header from "./components/Header/Header";
import TopSection from "./components/TopSection/TopSection";
import Posts from "./components/Posts/Posts";
import Team from "./components/Team/Team";
import React from "react";

function App() {
  return (
    <div className="App">
      <Header />
      <TopSection />
      <Posts />
      <Team />
    </div>
  );
}

export default App;
